import React, { Fragment } from 'react'
import Link from 'gatsby-link'
import RegisterForm from '../components/enqForm'
import styled from 'styled-components'
import FooterForm from './footerForm'
import * as vars from '../style/vars'
import { above, below } from '../style/functions'
import LogoSvg from '../svg/logo'
import GlenVill from '../../static/images/glenvill_developments_small.png'
import Twitter from '../svg/twitter.svg'
import Fb from '../svg/facebook.svg'
import Insta from '../svg/instagram.svg'
import AppIco from '../svg/ico-yarrabend-residents-app.svg'
import disclaimerPDF from '../../static/yarrabend-disclaimer-nov2020.pdf'

import circleArrow from '../svg/right-circle-white.svg'

const Footer = (props) => {
	function scroll(e) {
		if (typeof window !== `undefined`) {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		}
	}
	let property = ''
	if (props.type === 'product') {
		property = props.slug
	}

	return (
		<Fragment>
			{props.slug !== 'thank-you' && props.productHide == false && (
				<FooterForm
					property={property}
					utm={props.utm}
					updateFormDetails={(first_name, last_name, phone, email, property) =>
						props.updateFormDetails(first_name, last_name, phone, email, property)
					}
				/>
			)}
			<FooterWrapper>
				<div className='grid'>
					<div className='inner'>
						<Box className='flex'>
							<Col>
								<li>
									<Link to='/masterplan' className='white'>
										Masterplan
									</Link>
								</li>
							</Col>
							<Col>
								<li>
									<Link to='/lifestyle' className='white'>
										Lifestyle
									</Link>
								</li>
								<li>
									<Link to='/lifestyle/health--wellness'>Health & Wellness</Link>
								</li>
								<li>
									<Link to='/lifestyle/technology'>Technology</Link>
								</li>
								<li>
									<Link to='/lifestyle/sustainability'>Sustainability</Link>
								</li>
								<li>
									<Link to='/lifestyle/food--entertainment'>
										Food & Entertainment
									</Link>
								</li>
								<li>
									<Link to='/lifestyle/art--design'>Art & Design</Link>
								</li>
								<li>
									<Link to='/lifestyle/knowledge'>Knowledge</Link>
								</li>
								<li>
									<Link to='/lifestyle/the-hub'>The Hub</Link>
								</li>
								<li>
									<Link to='/lifestyle/parks'>Parks</Link>
								</li>
							</Col>
							<Col>
								<li>
									<Link to='/now-selling' className='white'>
										Now Selling
									</Link>
								</li>
								<li>
									<Link to='/seren-row-penthouses'>Signature Club Penthouses</Link>
								</li>
								<li>
									<Link to='/parkview-townhouses'>Parkview Townhouses</Link>
								</li>
								<li>
									<Link to='/seren-row'>Seren Row Apartments</Link>
								</li>
								<li>
									<Link to='/tambour'>Warehouse-Style Residences</Link>
								</li>
							</Col>
							<Col>
								<li>
									<Link to='/yarrabend-residents-app' className='white'>
										YarraBend Residents App
									</Link>
								</li>
								<li>
									<Link to='/location' className='white'>
										Location
									</Link>
								</li>
								<li>
									<Link to='/project-team' className='white'>
										Project Team
									</Link>
								</li>
								<li>
									<Link to='/news' className='white'>
										Media
									</Link>
								</li>
								<li>
									<Link to='/contact' className='white'>
										Contact
									</Link>
								</li>
							</Col>
						</Box>
						<Box>
							<Title />
							<Links>
								<div className='developer'>
									<a href='https://yarrabend.com.au/' target='_blank'>
										<LogoSvg />
									</a>
									<a href='https://glenvill.com.au/' target='_blank'>
										<span>Proudly developed by</span>
										<img src={GlenVill} alt='Glenvill logo' />
									</a>
								</div>
								<div className='social'>
									<a href='https://www.facebook.com/yarrabend' target='_blank'>
										<img src={Fb} alt='Glenvill logo' />
									</a>
									<a href='https://www.instagram.com/yarrabend_/' target='_blank'>
										<img src={Insta} alt='Glenvill logo' />
									</a>
									<a href='/yarrabend-residents-app/'>
										<img src={AppIco} alt='YarraBend Residents App icon' />
									</a>
								</div>
								<div className='return'>
									<a
										href=' https://prismic-io.s3.amazonaws.com/yarrabend/ced7c76b-d136-4262-a592-ede0b11241ff_Due+diligence+checklist.pdf'
										target='_blank'
									>
										Due Diligence
									</a>
									<a
										href=' https://prismic-io.s3.amazonaws.com/yarrabend/87bc33a4-d4bf-43e1-87d8-63d835b31421_YarraBend+Privacy+Policy_JULY2020.pdf'
										target='_blank'
									>
										Privacy Policy
									</a>
									<a href={disclaimerPDF} target='_blank' download>
										Disclaimer
									</a>
									<a
										href='https://app.propertyshell.com/auth/default/login'
										target='_blank'
									>
										Agent Login
									</a>
									<div onClick={scroll} to='/'>
										<span>Return to top</span>
									</div>
								</div>
							</Links>
						</Box>
					</div>
				</div>
			</FooterWrapper>
		</Fragment>
	)
}

const FooterWrapper = styled.footer`
	background: ${vars.colors.body};
	padding: 8rem 0 6rem;
	color: ${vars.colors.blank};
	position: relative;
	z-index: 6;
	width: 100%;
	left: 0;
	right: 0;
	.inner {
		display: flex;
		flex-wrap: wrap;
	}
	${below.tablet`
    flex-wrap: nowrap;
    flex-direction: column;
    padding: ${vars.padding.tabInner}rem 0 0;

  `};
`

const Box = styled.div`
	width: 100%;
	margin: 0 0.5%;
	margin-bottom: ${vars.padding.mobOuter * 1.5}rem;
	&:nth-of-type(4) {
		width: 100%;
		margin-bottom: 1rem;
	}

	&.flex {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: 4rem;
		${below.tablet`
         margin-bottom: 0;
      `};
	}

	span.view-map {
		position: relative;
		left: -5px;
		font-size: 1.4rem;
		&:before {
			content: '';
			display: inline-block;
			width: 3rem;
			height: 3rem;
			background: url(${circleArrow});
			vertical-align: middle;
			margin-right: ${vars.padding.mobOuter * 2}px;
		}
	}

	${below.tablet`
    width: 98%;
  `};
	${below.mobile`
	 margin-bottom: 3rem;
	`}
`

const Col = styled.ul`
	margin-left: 0;
	li {
		list-style: none;
		a {
			text-decoration: none;
			/* border-bottom-width: 0; */
			color: #777777;
			:after {
				content: none;
			}
			&.white {
				color: white;
			}
		}
	}

	&:last-of-type {
		li {
			margin-right: 6vw;
			margin-bottom: 2rem;
			&:last-of-type {
				margin-bottom: 0;
			}
		}
	}

	${below.tablet`
      font-size: 1.3rem;
      flex: 0 1 40%;
      margin-left: 0;
   `};
`

const Title = styled.p`
	border-bottom: 2px solid ${vars.colors.blank};
	padding-bottom: 1rem;
	margin-bottom: 1rem;
	${below.mobile`
	 	margin-bottom: 3rem;
	 `}
`

const Contact = styled.div`
	display: flex;
	a {
		transition: margin-left 0.3s;
		&:hover {
			margin-left: 1rem;
		}
	}
	.hours {
		width: 70%;
		p:first-of-type {
			padding-bottom: 5px;
		}
	}

	${below.tablet`
    flex-direction: column;
    .hours {
       width: 100%;
    }

    .phone {
      margin-top: 1rem;
    }
  `};
`

const Links = styled.div`
	display: flex;
	margin: ${vars.padding.mobInner / 1.2}rem 0;

	div {
		display: flex;
		align-items: flex-end;
	}

	.developer {
		width: 45%;
		justify-content: space-between;

		a {
			width: 35%;
			text-decoration: none;
			${below.mobile`
				 	display: block;
				 `}

			svg {
				max-width: 138px;
				max-height: 22px;
				${below.mobile`
						max-width: 110px;
            max-height: 17px;
						`}
			}

			img {
				max-width: 90px;
				max-height: 33.8px;
				vertical-align: middle;
				${below.mobile`
						max-width: 72px;
            max-height: 26px;
						`}
			}

			&:last-child {
				width: 55%;
				img {
					width: 55%;
				}
				span {
					padding-right: 1rem;
					font-size: 1.2rem;
				}
			}
		}
	}

	.social {
		width: 20%;
		justify-content: center;
		a {
			margin: 0 0.5rem;
		}

		img {
			height: 100%;
			width: 28px;
			${below.mobile`
         width: 22px;

						`}
		}
	}

	.return {
		justify-content: flex-end;
		width: 35%;
		font-size: 1.4rem;
		text-decoration: underline;
		cursor: pointer;

		${below.mobile`
      font-size: 1.1rem;
      `};

		a {
			padding-bottom: 5px;
			margin-right: 1em;
		}
		span:after {
			content: '';
			display: inline-block;
			width: 2rem;
			height: 2rem;
			margin-left: 1rem;
			background: url(${circleArrow});
			vertical-align: middle;
			transform: rotate(-90deg);
			${below.mobile`
					width: 1.5rem;
					height: 1.5rem;
				 `};
		}
	}

	${below.tablet`
    flex-wrap: wrap
    margin: 0;

    .developer {
      width: 100%;
			display:grid;

      a {
        width: 100%;

        &:last-child {
          width: 100%;
					padding-top: ${vars.padding.mobInner}rem;
        }
      }
    }
    .social {
      width: 100%;
      margin: 1.5rem 0 .5rem;
			justify-content: left;
    }
    .return {
       padding-top:1em;
      width: 100%;
			justify-content: left;
    }

  `};
	${below.mobile`
    display: block;
    .developer {
      width: auto;
			display:block;
			float: left;

    }
    .social {
      width: auto;
      float: right;
			margin-top:0;
			margin-bottom: 1.3rem;
    }
    .return {
      width: auto;
      float: right;
			clear: right;
			margin-right: 7px;
    }

  `};
`

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js